module.exports = __webpack_public_path__ + "img/yuanshi.07f49e7a.jpg";